'use client';

import React, { FC, useEffect, useRef, useState } from 'react';

import { Button } from 'components/ui/button';
import { ChevronIcon } from 'components/icons/v2';

interface TruncateTextProps {
  text: string;
  lineHeight: number;
}

const TruncateText: FC<TruncateTextProps> = ({ text, lineHeight }) => {
  const [isTruncated, setIsTruncated] = useState<boolean>(false);
  const [showButton, setShowButton] = useState<boolean>(true);
  const [containerHeight, setHeight] = useState<number>(0);

  const textRef = useRef<HTMLParagraphElement | null>(null);

  useEffect(() => {
    const checkHeight = () => {
      if (textRef.current) {
        const containerHeight = textRef.current.clientHeight;
        const maxHeight = lineHeight * 5;

        setShowButton(() => containerHeight > maxHeight);
        setIsTruncated(() => containerHeight > maxHeight);
        setHeight(() => containerHeight);
      }
    };

    checkHeight();
    window.addEventListener('resize', checkHeight);

    return () => {
      window.removeEventListener('resize', checkHeight);
    };
  }, [text, lineHeight]);

  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  return (
    <div className="w-full flex flex-col gap-2">
      <p
        ref={textRef}
        className={`overflow-hidden transition-all duration-300 ease-in-out${isTruncated ? ' text-ellipsis' : ''}`}
        style={{
          lineHeight: `${lineHeight}px`,
          height: isTruncated ? `${lineHeight * 5}px` : containerHeight ? `${containerHeight}px` : `auto`
        }}
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {showButton && (
        <Button
          className="p-0 self-end"
          variant="nakedBrandLink"
          size="x-small"
          onClick={toggleTruncate}
        >
          {isTruncated ? (
            <>
              Show more
              <ChevronIcon className="" />
            </>
          ) : (
            <>
              Show less
              <ChevronIcon className="rotate-180" />
            </>
          )}
        </Button>
      )}
    </div>
  );
};

export default TruncateText;
